import React, { useState } from "react";
import { Stack, CardActions, Grid } from "@mui/material";
import { InnerWrapper, OuterWrapper } from "../wrapper/wrapper";
import {
  CardBody,
  CardData,
  CardImage,
  CtaButton,
  Domain,
  InternshipName,
  Tag,
  Title,
} from "./enrolled.components";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import SubmitWorkDialog from "./workDialog/submitWork";
import DownloadCertificate from "./downloadDialog/downloadCertificate";

function EnrolledInterships({ enrolledInternships }) {
  const [uploadWork, setUploadWork] = useState(false);
  const [downloadCertificate, setDownloadCertificate] = useState(false);
  const [internshipID, setInternshipID] = useState("");
  const [internshipName, setInternshipName] = useState("");
  const [submissionDate, setSubmissionDate] = useState("");
  const [enrollDate, setEnrollDate] = useState("")

  return (
    <>
      <SubmitWorkDialog
        internshipID={internshipID}
        uploadWork={uploadWork}
        setUploadWork={setUploadWork}
      />
      <DownloadCertificate
        internshipName={internshipName}
        enrollDate={enrollDate}
        submissionDate={submissionDate}
        downloadCertificate={downloadCertificate}
        setDownloadCertificate={setDownloadCertificate}
      />
      <OuterWrapper sx={{ pt: "150px", bgcolor: "#F8FBFE" }}>
        <InnerWrapper>
          <Title px={1.5}>Enrolled Courses</Title>
          <Grid container px={1.5} pb={10}>
            {enrolledInternships.map((data) => {
              return (
                <CardBody
                  item
                  sx={{
                    maxWidth: { sm: 350, md: 400 },
                    ml: { md: 2 }
                  }}
                >
                  <CardImage component="img" image={data.imgUrl} alt="" />
                  <CardData>
                    <Domain>{data.domain}</Domain>
                    <InternshipName>{data.name}</InternshipName>
                    <Stack
                      direction="row"
                      justifyContent="flex-start"
                      alignItems="center"
                      spacing={1.25}
                    >
                      {data.tags.map((tag) => {
                        return <Tag>{tag}</Tag>;
                      })}
                    </Stack>
                  </CardData>

                  <CardActions
                    sx={{
                      justifyContent: "space-between",
                      px: 3.5,
                      py: 1.5,
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      handleButtonClick(data.name, data.enrollDate, data.submissionDate, data.internshipID, data.verified)
                    }
                  >
                    <CtaButton>
                      {data.verified === -1
                        ? "Submit Work"
                        : data.verified === 0
                          ? "Under Review"
                          : data.verified === 1
                            ? "Completed / Download Certificate"
                            : data.verified === 2 ? "Submit Work With Correct Format" : ""}
                    </CtaButton>
                    <CtaButton>
                      <ArrowForwardIcon />
                    </CtaButton>
                  </CardActions>
                </CardBody>
              );
            })}
          </Grid>
        </InnerWrapper>
      </OuterWrapper>
    </>
  );

  function handleButtonClick(name, startDate, endDate, id, verifyStatus) {
    if (verifyStatus === -1 || verifyStatus === 2) {
      setInternshipID(id);
      setUploadWork(true);
    } else if (verifyStatus === 1) {
      setInternshipName(name);
      setEnrollDate(startDate);
      setSubmissionDate(endDate);
      setDownloadCertificate(true);
    }
  }
}

export default EnrolledInterships;
